import React from 'react'
import './Info.css'
import acc_gy_icon from '../img/acc-gy-icon.svg'
import acc_gr_icon from '../img/acc-gr-icon.svg'
import acc_or_icon from '../img/acc-or-icon.svg'
import acc_rd_icon from '../img/acc-rd-icon.svg'
import warning_gy_icon from '../img/warning-sm-gy-icon.svg'
//import warning_or_icon from '../img/warning-or-icon.svg'
import warning_rd_icon from '../img/warning-sm-rd-icon.svg'


import DonutSummary from '../components/DonutSummary'; 

//function Info(props){
function Info({ site, filter, showLpp, showMel, showEEAA,show980,show960, handleShow,showAll,kpi }) {

  // valores seguros por si no llegan
  const less24 = kpi?.less24 ?? 0;
  const between24and48 = kpi?.between24and48 ?? 0;
  const more48 = kpi?.more48 ?? 0;
  const total = kpi?.total ?? 0;
  const perc = kpi?.perc ?? 0;

  //if(props.site==="nitro"){
  if(site==="nitro"){
    return(

      
        <div className='info-container'>

          <div className='btn-container'>
            {/* Botones para cambiar el filtro */}
            <button
              className={`button ${filter === 'ALL' ? 'selected' : ''}`}
              onClick={() => handleShow('ALL')}
            >
              FLOTA
            </button>



          <div className="divider-container">
            <div className="divider-line left" />
            <span className="divider-text">Finning</span>
            <div className="divider-line right" />
          </div>



          <div className="horizontal-btns">
                <button
                  className={`button grid-btn ${filter === '797B_LPP' ? 'selected' : ''}`}
                  onClick={() => handleShow('797B_LPP')}
                >
                797B
                </button>

                {<button
                  className={`button grid-btn ${filter === '798_LPP' ? 'selected' : ''}`}
                  onClick={() => handleShow('798_LPP')}
                >
                798AC
                </button>
                }
          </div>





          <div className="divider-container">
            <div className="divider-line left" />
            <span className="divider-text">Power Train</span>
            <div className="divider-line right" />
          </div>

          <div className="horizontal-btns">
                {<button
                  className={`button grid-btn ${filter === '797B_PTT' ? 'selected' : ''}`}
                  onClick={() => handleShow('797B_PTT')}
                >
                797B
                </button>
                }
          </div>







          <div className="divider-container">
            <div className="divider-line left" />
            <span className="divider-text">Escondida</span>
            <div className="divider-line right" />
          </div>





          <div className="horizontal-btns">
            <button
              className={`button grid-btn ${filter === '797B' ? 'selected' : ''}`}
              onClick={() => handleShow('797B')}
            >
              797B
            </button>
            
             <button
              className={`button grid-btn ${filter === '798' ? 'selected' : ''}`}
              onClick={() => handleShow('798')}
            >
              798AC
            </button>
          </div>

          <div className="horizontal-btns">

            <button
              className={`button grid-btn ${filter === '960E' ? 'selected' : ''}`}
              onClick={() => handleShow('960E')}

            >
              960E
            </button>

            <button
              className={`button grid-btn ${filter === 'EEAA' ? 'selected' : ''}`}
              onClick={() => handleShow('EEAA')}
            >
              EEAA
            </button>

          </div>

            <div className="horizontal-btns">
                <button className={`button grid-btn ${filter === '854K' ? 'selected' : ''}`}
                  onClick={() => handleShow('854K')}
                >854K</button>

                <button className={`button grid-btn ${filter === '777' ? 'selected' : ''}`}
                  onClick={() => handleShow('777')}
                >777</button>
            </div>



            <div className="horizontal-btns">
                <button className={`button grid-btn ${filter === '24M' ? 'selected' : ''}`}
                  onClick={() => handleShow('24M')}
                >24M</button>

                <button className={`button grid-btn ${filter === '988' ? 'selected' : ''}`}
                  onClick={() => handleShow('988')}
                >988</button>
            </div>


            <div className="horizontal-btns">
                <button className={`button grid-btn ${filter === '793F' ? 'selected' : ''}`}
                  onClick={() => handleShow('793F')}
                >793F</button>

                <button className={`button grid-btn ${filter === '994F' ? 'selected' : ''}`}
                  onClick={() => handleShow('994F')}
                >994F</button>
            </div>

           

           



            
          </div>

          {/*
            <p className="title">Presion Acumuladores</p>
            <div className="lorem">
              
                <div>
                  <img src={acc_gy_icon} alt = " "/>
                  <span className="infoStyle"> Fuera de linea</span>
                </div>
                <div>
                  <img src={acc_gr_icon} alt = " "/>
                  <span className="infoStyle"> Presión normal (1050 ± 50 psi)</span>
                </div>
                <div>
                  <img src={acc_or_icon} alt = " "/>
                  <span className="infoStyle"> <img src={warning_gy_icon}  alt = " "/> Presion menor a 800psi</span>
                  </div>
                <div>
                  <img src={acc_rd_icon} alt = " "/>
                  <span className="infoStyle"> <img src={warning_rd_icon} alt = " "/> Presion menor a 600psi</span>
                </div>

                <br></br>

                */}

                
                
                {/*<p>La carga de nitrógeno proporciona energía para el frenado normal y para frenado secundario si se detiene el flujo desde la bomba de freno. La carga de nitrógeno para los acumuladores del freno de servicio y de estacionamiento es 1050 ± 50 psi a una temperatura de 21 ° C .
                </p> */}
                
                
                
                {/*<p><img src={warning_gy_icon} alt = " "/><i> La especificaci&oacute;n de la presión es con el motor detenido</i></p>
                

                <p><img src={warning_gy_icon} alt = " "/><i> La presi&oacute;n es susceptible a la temperatura ambiente.</i></p>
                <br></br>
                <p>Los acumuladores mantienen el sistema de direcci&oacute;n y frenado activos si falla la bomba hidr&aacute;ulica. Almacenan presi&oacute;n con nitr&oacute;geno, garantizando la operaci&oacute;n de emergencia y absorbiendo fluctuaciones del sistema para mayor seguridad y estabilidad.
                </p>
                */}



                {/*<p>La presión de carga de nitrógeno es de 1500 psi a 21 ° C ( Motor detenido)
                </p>*/}

                
            {/*</div>*/}






            <div style={{ padding: "12px 8px" ,display: "flex", justifyContent: "center", alignItems: "center"}}>
                <DonutSummary
                  value={less24}
                  total={total}
                   perc={perc}
                  title="ONLINE"
                  subtitle="Ultimas 24 hrs"
                  size={100} 
                  // size={160}          // opcional
                  strokeWidth={12}    // opcional
                  color="#abfdae"     // opcional (tu verde)
                  track="#5a5a5aff"     // opcional
                  // bg="#3f3f3f"        // opcional (fondo oscuro)
                />
            </div>




        </div>
    )
  }

  //else if(props.site==="level"){
  else if(site==="level"){
    return(
      
        <div className="info-container">

<div>
            {/* Botones para cambiar el filtro */}
            <button
              className={`button ${filter === 'LPP' ? 'selected' : ''}`}
              onClick={showLpp}
            >
            LPP
            </button>
            <button
              className={`button ${filter === 'MEL' ? 'selected' : ''}`}
              onClick={showMel}
            >
              MEL
            </button>
            <button
              className={`button ${filter === 'EEAA' ? 'selected' : ''}`}
              onClick={showEEAA}
            >
              EEAA
            </button>
            <button
              className={`button ${filter === 'ALL' ? 'selected' : ''}`}
              onClick={showAll}
            >
              Flota
            </button>
          </div>

          
            <p className="title">Niveles combustible  Hidraulico  Refrigerante</p>
            <div className="lorem">
                <p>Los niveles son monitoreados en tiempo real.</p>
                <p>Hay que considerar que las especificaciones de niveles pueden estar con el motor detenido.</p>
                <p>El nivel de refrigerante es monitoreado por dos sensores ubicados en ambos tanques de expansion.</p>
                <p>El nivel de combustible permite obtener los litros actuales, lo rellenado y la autonomima restante entre otros parametros.</p>
            </div>
        </div>
    )
  }
}

export default Info

